import {NgModule} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {MatInputModule} from '@angular/material/input';
import {IMaskModule} from 'angular-imask';
import {PhoneComponent} from './phone.component';


@NgModule({
  imports: [
    ReactiveFormsModule,
    MatInputModule,
    IMaskModule
  ],
  declarations: [
    PhoneComponent
  ],
  entryComponents: [
    PhoneComponent
  ],
  exports: [
    PhoneComponent
  ]
})

export class PhoneModule {}
